import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, type, flightType }) => ({
  backgroundColor: theme.palette.fly.inputBg,
  width: "calc(50% - 6.5px)",
  minWidth: 0,
  height: 60,
  position: "relative",
  transition: "all .2s ease",
  border: "1px solid transparent",
  borderRadius: 6,

  "&:hover": {
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },

  [theme.down("md")]: {
    width: flightType !== FLIGHT_TYPE_CF ? 374.5 : 280,
  },

  [theme.down("sm")]: {
    width: "100%",
  },

  "&.notFilled": {
    backgroundColor: "#f5d1d1",
    border: `1px solid ${theme.palette.error.main}`,
    transition: "background-color .3s ease",
  },

  "&:has(input:focus)": {
    boxShadow: `0 0 0 1px ${theme.palette.fly.brand}`,
  },
}));

export const AirportInput = styled("input")(({ theme, type, flightType }) => ({
  ...theme.paddings(0, 75, 0, 50),
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  border: "none",
  borderRadius: 6,
  fontSize: 15,
  fontWeight: 500,
  color: theme.palette.text.primary,
  background: "none",
  transition: "all .2s ease",

  "&:focus, &:active": {
    outline: "none",
  },
}));

export const InputIconBlock = styled("span")(({ theme }) => ({
  display: "flex",
  position: "absolute",
  left: 25,
  top: 20,
  zIndex: 5,
  color: theme.palette.fly.placeholder,
  fontSize: 20,
}));

export const FlagImage = styled("img")(({ theme }) => ({
  width: 22,
  height: 22,
}));

export const InputPlaceholder = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 15, 0, 54),
  height: 60,
  width: "100%",
  position: "absolute",
  left: 0,
  top: 0,
  fontSize: 12,
  fontWeight: 500,
  transition: "all .2s ease",
  color: theme.palette.fly.placeholder,
  pointerEvents: "none",

  "&.not-empty": {
    ...theme.paddings(4, 15, 0, 50),
    fontSize: 11,
  },
}));

export const InputAirportCodeAndClearBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  padding: 5,
  gap: 5,
  position: "absolute",
  right: 15,
  top: "calc(50% - 14px)",
  backgroundColor: "transparent",

  "& > span": {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.fly.brand,
    lineHeight: 1,
  },

  "& > svg": {
    fontSize: 18,
    color: theme.palette.text.muted,
    cursor: "pointer",
    transition: "all .2s ease",

    "&:hover": {
      color: theme.palette.fly.brand,
      transform: "scale(1.1)",
    },
  },
}));
